<div class="block form-admin">
	<header class="header-admin">
		<h1 class="admin">Classification produit</h1>
	</header>
	<router-outlet></router-outlet>
</div>